import { useCallback, useState } from 'react';

export const usePagination = (initialPageNumber: number | null = 0, initialPageSize: number | null = 20) => {
    const [pageNumber, setPageNumber] = useState<number | null>(initialPageNumber);
    const [pageSize, setPageSize] = useState<number | null>(initialPageSize);

    const nextPage = useCallback(() => {
        setPageNumber((prev) => (prev ? prev + 1 : 1));
    }, []);

    const previousPage = useCallback(() => {
        setPageNumber((prev) => (prev && prev > 0 ? prev - 1 : 0));
    }, []);

    const handlePageSize = useCallback((newPageSize: number) => {
        setPageNumber(0);
        setPageSize(newPageSize);
    }, []);

    return {
        pageNumber,
        setPageNumber,
        nextPage,
        previousPage,
        pageSize,
        setPageSize: handlePageSize,
    };
};
export type PaginationHandling = ReturnType<typeof usePagination>;
